export const matchesTemplate = (errorMessage: string, template: string) => {
     const escapedTemplate = template.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
     const regexPattern = `^${escapedTemplate.replace(/\\{(.*?)\\}/g, "(.*)")}$`;
     const regex = new RegExp(regexPattern, "i");
     return regex.test(errorMessage);
  }